<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="epigraph"><span>I shall not be there. I shall rise and pass. Bury my heart at Wounded Knee.</span></p>
<p class="center"><span>—<span class="small">STEPHEN VINCENT BENET</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 8-epigraph.vue?161e9bb6